import { render, staticRenderFns } from "./qualities-add.vue?vue&type=template&id=5136f7a5&scoped=true&"
import script from "./qualities-add.vue?vue&type=script&lang=js&"
export * from "./qualities-add.vue?vue&type=script&lang=js&"
import style0 from "./qualities-add.vue?vue&type=style&index=0&id=5136f7a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136f7a5",
  null
  
)

export default component.exports